export default __webpack_public_path__ + "static/media/cpv_48_software.c62fdc1c.svg";